import {
  WbLink,
  getTruncateMaxLinesStyle,
  WbTooltip,
} from '@agilelab/plugin-wb-platform';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(
  theme => ({
    root: {
      fontSize: theme.typography.h5.fontSize,
      color: theme.palette.primary.main,
      fontWeight: 500,
    },
    regular: {
      ...getTruncateMaxLinesStyle(2, false),
      wordBreak: 'break-word',
    },
    concise: {
      wordBreak: 'break-all',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      maxWidth: '450px',
      display: 'block',
      textOverflow: 'ellipsis',
      fontSize: theme.typography.body1.fontSize,
    },
  }),
  { name: 'ResultTitle' },
);

type ResultTitleProps = {
  title: string;
  location: string;
  concise?: boolean;
};

export const ResultTitle = ({ title, location, concise }: ResultTitleProps) => {
  const classes = useStyles();

  return (
    <WbTooltip title={title}>
      <div>
        <WbLink
          to={location}
          className={clsx(
            classes.root,
            concise ? classes.concise : classes.regular,
          )}
        >
          {title}
        </WbLink>
      </div>
    </WbTooltip>
  );
};
